import React from 'react'

interface Props {
    className: string
}

const LiveChatOfflineIcon = ({ className }: Props) => (
    <div className={className}>
        <svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0.5 0V10.001H3.5V14L6.5 10.001H14.5V0H0.5ZM1.5 1.001H13.5V9H6L5.7 9.4L4.5 11.001V9H1.5V1.001Z"
                fill="#CBCBCB"
            />
        </svg>
    </div>
)

export default LiveChatOfflineIcon
